import React, { Component } from "react";
import PropTypes from "prop-types";
import withLogFeatureUsage from "react/containers/AnalyticContainer";
import CatalogAnchor from "react/views/catalogAnchor/CatalogAnchor";

class TrackedCatalogLink extends Component {
    render() {
        const ComponentWithLink = withLogFeatureUsage(CatalogAnchor, this.props.featureType, this.props.uniqueId);

		return (
				<ComponentWithLink catalogLink={this.props.catalogLink}>
					{this.props.children}
				</ComponentWithLink>
		);
    }
}

TrackedCatalogLink.propTypes = {
    featureType: PropTypes.object.isRequired,
	uniqueId: PropTypes.string.isRequired,
	catalogLink: PropTypes.object,
}

export default TrackedCatalogLink;



// WEBPACK FOOTER //
// ./src/react/views/generic/TrackedCatalogLink.jsx